import { Colors } from '@drivably-apps/component-lib';

/**
 * Generate a list of strings from a single string, split by a delimiter
 */
export const splitLineBreaks = (text = '', delimiter = '\\n') =>
  text.split(delimiter).filter(Boolean);

// Convert snake case text to a user friendly one
export const normalizeSnakeCase = (text = '') =>
  text
    .split('_')
    .map((str) => str.slice(0, 1).toUpperCase() + str.slice(1, str.length))
    .join(' ');

// Type cast numbers
export const convertStringToNumber = (text = '') =>
  Number(`${text}`.replace(/\D/g, ''));

// Filter alphanumeric characters only
export const pickAlphanumeric = (text = '') =>
  text.replace(/[^a-zA-Z0-9]/g, '');

export const replaceByLine = (
  originalText: string | string[],
  key: string,
  replaceText: string
) => {
  return Array.isArray(originalText)
    ? originalText.map((line) => replaceMultipleTexts(line, key, replaceText))
    : replaceMultipleTexts(originalText, key, replaceText);
};

// Transform camel/kebab case to text
export const transformCamelCaseToText = (text: string) => {
  const result = text.replace(/([A-Z])/g, ' $1');
  return result.charAt(0).toUpperCase() + result.slice(1);
};

export const transformSneakCaseToText = (text: string) => {
  return text
    .replace(/^[-_]*(.)/, upperCaseChar.bind(this, '')) // Initial char (after -/_)
    .replace(/[-_]+(.)/g, upperCaseChar.bind(this, ' ')); // First char after each -/_;
};

const upperCaseChar = (extraText: string, _: unknown, value: string) =>
  `${extraText}${value.toUpperCase()}`;

/** Convert a string to capital or title case. For example, "hello world" becomes "Hello World" */
export const toCapitalCase = (str = '') => {
  const words = str.toLowerCase().split(' ');

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i].charAt(0).toUpperCase() + words[i].substring(1);
  }

  return words.join(' ');
};

const SpecialCharactersRegex = /[.*+?^${}()|[\]\\]/;

export const replaceMultipleTexts = (
  text = '',
  pattern = '',
  replacement = ''
) => {
  // Before converting pattern to regex, escape special characters first (ex. "{0}" -> "\{0\}")
  const parsedPattern = pattern.replace(SpecialCharactersRegex, '\\$&');

  // Create regex that checks multiple instances of the pattern
  const patternRegex = new RegExp(parsedPattern, 'g');

  return text.replace(patternRegex, replacement);
};

export const RegexVIN = /^[A-HJ-NPR-Z0-9]{12}[0-9]{5,6}$/;

export const parseIfJsonString = (
  input: string
): string | { base: string; overrideProps: Colors | undefined } | undefined => {
  // convert to stringified json
  const jsonString = input
    .replace(/(['"])?([a-zA-Z0-9_]+)(['"])?\s*:/g, '"$2":') // Add double quotes around property names
    .replace(/'/g, '"');
  try {
    const parsed = JSON.parse(jsonString);
    return parsed;
  } catch (e) {
    return jsonString;
  }
};
